import type { ObligationAssessmentResultsByObligationIdResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetLatestObligationAssessmentResultByObligationIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetLatestObligationAssessmentResultByObligationIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetLatestObligationAssessmentResultByObligationIdArgs = {
  obligationId: string;
};

/**
 * "Latest" obligation assessment result for an obligation. The data-layer read
 * returns rows ordered by TestDate desc, so the consumer takes `[0]`. Reuses
 * the `obligationAssessmentResultsByObligationId` procedure — the legacy
 * GraphQL query was the same filter + order, just consumed as a single latest
 * row.
 */
export const useGetLatestObligationAssessmentResultByObligationId =
  createQueryHook<
    UseGetLatestObligationAssessmentResultByObligationIdArgs,
    ObligationAssessmentResultsByObligationIdResponseRow[],
    GetLatestObligationAssessmentResultByObligationIdQuery
  >({
    trpcQueryOptions: (trpc, { obligationId }) =>
      trpc.frontend.obligationAssessmentResult.obligationAssessmentResultsByObligationId.queryOptions(
        { obligationId }
      ),
    mapTrpcDataToGraphQL: (data) => ({ obligation_assessment_result: data }),
    graphqlDocument: GetLatestObligationAssessmentResultByObligationIdDocument,
    graphqlVariables: ({ obligationId }) => ({ ObligationId: obligationId }),
  });
